import { render } from "./ItemDetailModal.vue?vue&type=template&id=3f963f48&scoped=true&ts=true"
import script from "./ItemDetailModal.vue?vue&type=script&lang=ts"
export * from "./ItemDetailModal.vue?vue&type=script&lang=ts"

import "./ItemDetailModal.vue?vue&type=style&index=0&id=3f963f48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f963f48"]])

export default __exports__